import { render, staticRenderFns } from "./NewZgbTeamMembersModify.vue?vue&type=template&id=ab0a6416"
import script from "./NewZgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./NewZgbTeamMembersModify.vue?vue&type=script&lang=js"
import style0 from "./NewZgbTeamMembersModify.vue?vue&type=style&index=0&id=ab0a6416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports